import { Dialog } from '@mui/material';
import { useEffect } from 'react'
import { IoClose } from 'react-icons/io5';
import { MdDoubleArrow } from "react-icons/md";
import { useTranslation } from 'react-i18next';

const EventModal = ({ displayModal, setDisplayModal }) => {
    const { t } = useTranslation('EventModal');
    const handleclose = () => {
        localStorage.setItem("eventModal", true);
        setDisplayModal(false);

    }
    useEffect(() => {
        const returnmodal = localStorage.getItem("eventModal");
        setDisplayModal(!returnmodal);
    }, [])
    return (
        <>
            {
                displayModal && (
                    <Dialog
                        open={true}
                        onClose={handleclose}
                        PaperProps={{
                            sx: {
                                borderRadius: "20px",
                                width: "630px",

                            },
                        }}
                    >
                        <div className="bg-white p-5  flex flex-col gap-3 rounded-[20px]">
                            <div className="div grid gap-2">
                                <div className="flex  items-start justify-between w-full ">
                                    <span className='text-[18px] font-[600] text-[#131415] '>{t("title")}</span>
                                    <span onClick={handleclose}><IoClose size={25} className='cursor-pointer' /></span>
                                </div>
                                <p className='text-[15px] text-[#535861] my-1'>{t("description")}</p>

                                <div className="bg-[#F6F6F6] p-3 rounded-[9px] grid gap-4 ">
                                    <p className='font-[600] text-[#131415] text-[18px] ' >{t("sub_title")}</p>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><MdDoubleArrow fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("title1")}: </span>{t("description1")}</p>
                                    </div>
                                    <div className='flex gap-2 text-[14px] items-start'>
                                        <span><MdDoubleArrow fill='#3686FF' size={25} /></span>
                                        <p className='text-[#535861]'><span className='font-[600] text-[#131415]'>{t("title2")} : </span> {t("description2")}</p>
                                    </div>

                                </div>

                                <p className='text-[15px] text-[#535861] my-1'><span className='font-[600] text-[#131415]'>{t("tutorialsInfo.sub_description")} </span>{t("tutorialsInfo.description")} <a href='#' target="_blank" className='text-[#3686FF] underline text-[15px]'>{t("tutorialsInfo.linkText")}</a> {t("tutorialsInfo.description1")}</p>
                                <p className='text-[15px] text-[#535861] my-1'><a href='#' target="_blank" className='text-[#3686FF] underline text-[15px]'>{t("tutorialsInfo.linkUrl")}</a> {t("createEvent.description")}</p>

                            </div>

                        </div>
                    </Dialog >
                )
            }
        </>
    )
}

export default EventModal